// extracted by mini-css-extract-plugin
export default {"dashboard-tools":"Dashboard_dashboard-tools__zt22I","user-menu":"Dashboard_user-menu__Q7x83"};